/// <reference path="../../src/typings/global.d.ts" />

export class AddressTypeAhead {
	private _url: string;
	private _displayingUnits: boolean;

	constructor(url: string) {
		this._url = url;
		this._displayingUnits = false;
	}

	Setup(typeaheadId: string, melissaKeyId: string, unitNumberId: string) {

		var typeaheadName = typeaheadId.split('_').join('.');
		var timeout: NodeJS.Timeout | undefined;

		$("#loadingSpinner").hide();

		let xhr: JQuery.jqXHR | null = null;

		$("#" + typeaheadId).on('input', function () {
			var typeAheadValue = $("#" + typeaheadId).val() as string[];
			if (!typeAheadValue || typeAheadValue[0].length === 0) {
				clearTimeout(timeout);
				timeout = undefined;
				$("#loadingSpinner").hide();
				if (xhr) {
					xhr.abort();
					xhr = null;
				}
			}
		});

		var map: { [key: string]: any } = {};
		var objects: string[] = [];
		var bestPictures;


		$("#" + typeaheadId).typeahead({
			highlight: true,
		},
			{
				limit: 20,
				source: (query, syncResults, asyncResults) => {
					if (query.length < 3) {
						return;
					}
					if (timeout) {
						clearTimeout(timeout);
						timeout = undefined;
					}

					if (xhr) {
						xhr.abort();
						xhr = null;
					}


					timeout = setTimeout(() => {
						$("#loadingSpinner").show();

						//not sure why this is needed either since with valid input bound model this is how it's named anyways
						//Handle unique typeahead field names
						//if ($(".icf-typeahead-field").length) {
						//	$(".icf-typeahead-field:not([readonly])").attr("id", typeaheadName);
						//	$(".icf-typeahead-field:not([readonly])").attr("name", typeaheadName.split('_').join('.'));
						//}

						//I'm not sure why this exists
						//Reset typeahead field to be unique
						//if ($(".icf-typeahead-field").length) {
						//	var uniqueFldId = Date.now();
						//	$(".icf-typeahead-field").attr("id", uniqueFldId);
						//	$(".icf-typeahead-field").attr("name", uniqueFldId);
						//}

						//var url = '@Url.Action("_TypeaheadAddress", "Eligibility")';

						xhr = $.ajax(
							{
								type: "GET",
								url: this._url + "?address=" + query,
								success: (jsonData) => {
									//console.log(jsonData);
									map = {};
									objects = [];
									//capitalization matters for .address since .Address doesn't work
									$.each(jsonData, (i, object) => {
										map[object.Address] = object;
										objects.push(object.Address);
									});
									asyncResults?.(objects);
									$("#loadingSpinner").hide();

									clearTimeout(timeout);
									timeout = undefined;
									xhr = null;
								}
							}) as JQuery.jqXHR;
					}, 400);
				},
				templates: {
					notFound: [
						'<div>',
						'No results found',
						'</div>'
					].join('\n')
				}
            }).on('keyup', (e: JQuery.KeyUpEvent) => {
				//Ignore tab and enter
				if (e.key !== "Tab" && e.key !== "Enter") {
					$("#" + melissaKeyId).val("");
				}
            });

        $("#" + typeaheadId).on('typeahead:selected', (_, item: string) => {
			//Check if selected address has units.
			if (map[item] && map[item].Units && map[item].Units.length > 0) {
				this._displayingUnits = true;
				$("#" + unitNumberId).empty();
				$("#" + unitNumberId).append($('<option></option>').attr('value', '').text(''));

				$.each(map[item].Units, (index, unit) => {
					$("#" + unitNumberId).append($('<option></option>').attr('value', unit.MelissaAddressKey).text(unit.UnitName));
				});

				$('#divUnit').show();
				$("#" + melissaKeyId).val('');
				this.SetCISTypeaheadError(typeaheadName, "");

			} else {
				this._displayingUnits = false;
				$('#divUnit').hide();
				if (map[item]) {
					$("#" + melissaKeyId).val(map[item].Key);
				} else {
					$("#" + melissaKeyId).val('');
				}

				var e: Event = new Event('icf-eligibility-selected');
				document.dispatchEvent(e);
				this.SetCISTypeaheadError(typeaheadName, "");
			}
		}).on('keyup', (e: JQuery.KeyUpEvent) => {
			//Ignore tab and enter
			if (e.key !== "Tab" && e.key !== "Enter") {
				$("#" + melissaKeyId).val("");
			}
		});

		$("#" + typeaheadId).on('blur', () => {
			//console.log("blur melissa: " + $("#" + melissaKeyId).val());
			//console.log("blur typeaheadName: " +$("#" + typeaheadId).val());

			//if CIS is chosen instead of Melissa, it will have a -1 MAK
			var rid = $("#" + melissaKeyId).val();
			if ((rid == "" || rid == null) && (this._displayingUnits == false)) {
				this.SetCISTypeaheadError(typeaheadName, "Please select an address from the list.");
				$("#" + typeaheadId).val("");

				var e: Event = new Event('icf-eligibility-deselected');
				document.dispatchEvent(e);

			} else {
				this.SetCISTypeaheadError(typeaheadName, "");
			}

		});

		const unitId = $("#" + unitNumberId).val() as string;
		$(unitId).change(() => {
			const melissaKey = $("#" + unitNumberId).val() as string;
			$(melissaKey).val(unitId);

			var e: Event = new Event('icf-eligibility-selected');
			document.dispatchEvent(e);
		});

		// --- Accessibility: fix invalid/incomplete ARIA emitted by typeahead.js ---
		const $tt = $("#" + typeaheadId);

		// The actual input the user types into after typeahead wraps the DOM.
		// It carries role="combobox" but is missing required combobox attributes.
		const $input = $tt.hasClass("tt-input") ? $tt : $tt.closest(".twitter-typeahead").find(".tt-input");

		// Give the suggestion menu a stable, valid id we can reference.
		const $menu = $tt.closest(".twitter-typeahead").find(".tt-menu");
		const listboxId = typeaheadId + "-listbox";
		$menu.attr({ id: listboxId, role: "listbox" });

		// Remove the deprecated/invalid attributes the library adds.
		$input.removeAttr("aria-owns");

		// Add the required combobox attributes with valid values.
		$input.attr({
			"aria-controls": listboxId,
			"aria-expanded": "false",
			"aria-autocomplete": "list"
		});
		$input.removeAttr("aria-activedescendant");

		$tt.on("typeahead:open", () => $input.attr("aria-expanded", "true"));
		$tt.on("typeahead:close", () => {
			$input.attr("aria-expanded", "false");
			$input.removeAttr("aria-activedescendant");
		});

		// Keep aria-activedescendant valid: only set it to a real suggestion id,
		// otherwise remove it entirely.
		$tt.on("typeahead:cursorchange", (_e: JQuery.TriggeredEvent, suggestion: unknown) => {
			const $cursor = $menu.find(".tt-cursor");
			if ($cursor.length && $cursor.attr("id")) {
				$input.attr("aria-activedescendant", $cursor.attr("id")!);
			} else {
				$input.removeAttr("aria-activedescendant");
			}
		});

		// Ensure each rendered suggestion is a valid listbox option with an id.
		$tt.on("typeahead:render", () => {
			$menu.find(".tt-suggestion").each((i, el) => {
				const $s = $(el);
				$s.attr("role", "option");
				if (!$s.attr("id")) {
					$s.attr("id", typeaheadId + "-option-" + i);
				}
			});
		});

		$("#" + typeaheadId).prop('autocomplete', 'notallowed');
	}

	SetCISTypeaheadError(name: string, message: string) {
		var span = $("span[data-valmsg-for=\"" + name + "\"]");
		if (span && span.length > 0) {
			$(span).html(message);
			if (message && message != "") {
				$(span).removeClass("field-validation-valid");
				$(span).addClass("field-validation-no-valid");
			} else {
				$(span).removeClass("field-validation-no-valid");
				$(span).addClass("field-validation-valid");
			}
		}
	}
}


